const ChartTooltip = () => null;
ChartTooltip.defaultProps = {};
export default ChartTooltip;
